import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "../Aibox/AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addHikvision, addLiveViewCamera, addSigfoxAPI, aiboxLogin, dahuaLogin, getCamectCameras, getDatabaseCamectIntegrations, hikvisionLogin, linkCamectCameras, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/pleasewait.json'
import successAnim from '../../../../../../assets/animations/success.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import { SelectButton } from 'primereact/selectbutton';
import { protocol } from 'socket.io-client';

import loggingInAnim from '../../../../../../assets/animations/pleasewait.json'
import { Dialog } from 'primereact/dialog';

const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const LiveViewCameraForm = ({ setShowVirtualSource, fetchVirtualSources, setShowSuccess, setShowFail, setFailMessage, showCamect, camectIntegrationType, camects, integrations }) => {

    console.log(camects);
    console.log(integrations);
    console.log(showCamect);
    

    // camectIntegrationType: 1 = Whole camect, 2 = Per camera arming (see Overview.js)
    const isPerCameraArming = camectIntegrationType == 2;
console.log(isPerCameraArming);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to add camera, please wait...")
    const [linkTitle, setLinkTitle] = useState("Camera added successfully!")
    const [loading, setLoading] = useState(false)

    const [cameraName, setCameraName] = useState("")

    const userID = useSelector(state => state.auth.userID);

    const [failReason, setFailReason] = useState("")
    const [streamType, setStreamType] = useState("Main stream")

    const [showLoggingIn, setShowLoggingIn] = useState(false)
    const [showAddingCams, setShowAddingCams] = useState(false)
    const [showAddingGeneric, setShowAddingGeneric] = useState(false)
    const [showDahuaLoginFailConfirm, setShowDahuaLoginFailConfirm] = useState(false)

    const [genericRtspURL, setGenericRtspURL] = useState("")
    const [selectedChannels, setSelectedChannels] = useState([]);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    // null = still loading, [] = none linked
    const [camectIntegrations, setCamectIntegrations] = useState(null)
    const [camectIntegrationsError, setCamectIntegrationsError] = useState(false)
    const [selectedCamect, setSelectedCamect] = useState(null)
    // null = still loading, [] = no cameras found
    const [availableCamectCameras, setAvailableCamectCameras] = useState(null)
    const [selectedCamectCameras, setSelectedCamectCameras] = useState([])

    useEffect(() => {
        console.log(selectedCamectCameras);
        console.log(availableCamectCameras);
    }, [selectedCamectCameras])

    const getCamectIntegrations = async () => {
        try {
            console.log('tried');
            const response = await getDatabaseCamectIntegrations(apiData, DeviceUUID, dispatch)
            console.log(response);
            const list = response?.integrationRelationships ?? response?.data ?? response
            setCamectIntegrations(Array.isArray(list) ? list : [])
            console.log(list);
        } catch {
            setCamectIntegrationsError(true)
            console.log('here');
            setCamectIntegrations([])
        }
    }

    const HandleLoadCameras = async (camect) => {
        try {
            const response = await getCamectCameras(apiData, DeviceUUID, camect.camect_id)
            console.log(response.cameras);

            for (const camera of response.cameras) {
                
            }
            setAvailableCamectCameras(Array.isArray(response?.cameras) ? response.cameras : [])
        } catch {
            setAvailableCamectCameras([])
        }
    }

    const HandleSelectCamect = (camect) => {
        setSelectedCamect(camect)
        setAvailableCamectCameras(null)
        setSelectedCamectCameras([])
        setModalPageIndex(26)
        HandleLoadCameras(camect)
    }

    const toggleCamectCamera = (camera) => {
        console.log(camera);
        setSelectedCamectCameras(prev =>
            prev.some(c => c.id === camera.id) ? prev.filter(c => c.id !== camera.id) : [...prev, camera]
        )
    }

    useEffect(() => {

        if (isPerCameraArming && showCamect){
            getCamectIntegrations()
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [rtspPortState, dispatchRTSPPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };

    const rtspChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        setGenericRtspURL(value)
    };

    const cameraNameChangeHandler = (e) => {
        const value = e.target.value;

        setCameraName(value)
    };

    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const rtspPortChangeHandler = (event) => {
        dispatchRTSPPortState({ type: 'USER_INPUT', val: event.target.value });
    }


    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const HandleAddCamera = async (type) => {
        setShowLoggingIn(true)
        if (type == "DAHUA"){
            const body = {
                deviceIp: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await dahuaLogin(apiData, body, dispatch)
            if (response.success){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${portState.value}/cam/realmonitor?channel=1&subtype=${streamType == "Main stream" ? 0 : 1}`
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        {
                            name: cameraName,
                            rtspURL: rtspURL,
                            type: "DAHUA",
                            defaultPinned: 0
                        }
                    ]
                };
                const addResponse = await addLiveViewCamera(apiData, body, dispatch)
                if (addResponse.success){
                    setShowLoggingIn(false)
                    //show success
                    HandleCloseModal();
                    setShowSuccess(true)
                    fetchVirtualSources();
                } else {
                    setShowLoggingIn(false)
                    setShowFail(true)
                    HandleCloseModal();
                    setFailMessage("Failed to add live view camera, please check your details and try again")
                }
            } else {
                setShowLoggingIn(false)
                setShowDahuaLoginFailConfirm(true)
            }
        } else if (type == "HIKVISION"){
            const body = {
                protocol: "http",
                hostName: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await hikvisionLogin(apiData, body, dispatch)
            if (response.success){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${rtspPortState.value}/streaming/channels/10${streamType == "Main stream" ? 1 : 2}`
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        {
                            name: cameraName,
                            rtspURL: rtspURL,
                            type: "HIKVISION",
                            defaultPinned: 0
                        }
                    ]
                };
                const addResponse = await addLiveViewCamera(apiData, body, dispatch)
                if (addResponse.success){
                    setShowLoggingIn(false)
                    //show success
                    HandleCloseModal();
                    setShowSuccess(true)
                    fetchVirtualSources();
                } else {
                    setShowLoggingIn(false)
                    setShowFail(true)
                    HandleCloseModal();
                    setFailMessage("Failed to add live view camera, please check your details and try again")
                }
            } else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Hikvision, please check your details and try again")
                setShowFail(true)
            }
        }
    }

    const HandleDahuaLoginFailContinue = async () => {
        setShowDahuaLoginFailConfirm(false)
        setShowLoggingIn(true)
        const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${portState.value}/cam/realmonitor?channel=1&subtype=${streamType == "Main stream" ? 0 : 1}`
        const body = {
            siteUUID: DeviceUUID,
            cameras: [
                {
                    name: cameraName,
                    rtspURL: rtspURL,
                    type: "DAHUA",
                    defaultPinned: 0
                }
            ]
        };
        const addResponse = await addLiveViewCamera(apiData, body, dispatch)
        if (addResponse.success) {
            setShowLoggingIn(false)
            HandleCloseModal();
            setShowSuccess(true)
            fetchVirtualSources();
        } else {
            setShowLoggingIn(false)
            setShowFail(true)
            HandleCloseModal();
            setFailMessage("Failed to add live view camera, please check your details and try again")
        }
    }

    const toggleButton = (index) => {
    setSelectedChannels(prev => {
      if (prev.includes(index)) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
    };

    const HandleLinkCamsForLiveView = async () => {
        let cameras = []
        for (const camera of selectedCamectCameras) {
            cameras.push({
                name: camera.name,
                cameraId: camera.id, //camect camera ID
                type: "CAMECT",
                defaultPinned: 0
            })
        }

        const body = {
            siteUUID: DeviceUUID,
            integrationId: selectedCamect.id,
            cameras: cameras
        }

        const response = await linkCamectCameras(apiData, body, dispatch)
        if (response?.success) {
            HandleCloseModal();
            setShowSuccess(true)
            fetchVirtualSources();
        } else {
            setShowFail(true)
            HandleCloseModal();
            setFailMessage("Failed to add Camect cameras, please try again")
        }
    }

    const HandleAddRTSP = async () => {
        setShowAddingGeneric(true)
        const body = {
                siteUUID: DeviceUUID,
                cameras: [
                    {
                        name: cameraName,
                        rtspURL: genericRtspURL,
                        type: "GENERIC",
                        defaultPinned: 0
                    }
                ]
            };
            const addResponse = await addLiveViewCamera(apiData, body, dispatch)
            if (addResponse.success){
                setShowAddingGeneric(false)
                HandleCloseModal();
                setShowSuccess(true)
                fetchVirtualSources();
            } else {
                setShowAddingGeneric(false)
                setShowFail(true)
                HandleCloseModal();
                setFailMessage("Failed to add camera, please check try again")
            }
    }

    const HandleAddChannels = async (type) => {
        setShowAddingCams(true);
        let addResponseCount = 0;

        //Check which button was pressed first - this if Dahua else ...

        for (let channel of selectedChannels) {
            if (type == "DAHUA"){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${portState.value}/cam/realmonitor?channel=${channel}&subtype=${streamType === "Main stream" ? 0 : 1}`;
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        { name: `${cameraName} - Cam ${channel}`, rtspURL, type: "DAHUA", defaultPinned: 0 }
                    ]
                };

                try {
                    const addResponse = await addLiveViewCamera(apiData, body, dispatch);
                    if (addResponse) addResponseCount++;
                } catch (err) {
                    console.error(`Failed to add camera for channel ${channel}`, err);
                }
            }
            if (type == "HIKVISION"){
                const rtspURL = `rtsp://${usernameState.value}:${passwordState.value}@${ipAddressState.value}:${rtspPortState.value}/streaming/channels/${channel}0${streamType === "Main stream" ? 1 : 2}`;
                const body = {
                    siteUUID: DeviceUUID,
                    cameras: [
                        { name: `${cameraName} - Cam ${channel}`, rtspURL, type: "HIKVISION", defaultPinned: 0 }
                    ]
                };

                try {
                    const addResponse = await addLiveViewCamera(apiData, body, dispatch);
                    if (addResponse) addResponseCount++;
                } catch (err) {
                    console.error(`Failed to add camera for channel ${channel}`, err);
                }
            }

        }

        setShowAddingCams(false);

        if (addResponseCount === selectedChannels.length) {
            fetchVirtualSources();
            HandleCloseModal();
            setShowSuccess(true);
        }
    };




    const HandleAddNVR = async (type) => {
        setShowLoggingIn(true)
        if (type == "DAHUA"){
            const body = {
                deviceIp: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await dahuaLogin(apiData, body, dispatch)
            if (response.success){
                setShowLoggingIn(false)
                setModalPageIndex(12)
            }
            else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Dahua, please check your details and try again")
                setShowFail(true)
            }
        }
        if (type == "HIKVISION"){
            const body = {
                protocol: "http",
                hostName: ipAddressState.value,
                port: Number(portState.value),
                username: usernameState.value,
                password: passwordState.value,
                userID: Number(userID)
            }

            const response = await hikvisionLogin(apiData, body, dispatch)
            if (response.success){
                setShowLoggingIn(false)
                setModalPageIndex(23) //choose channels
            }
            else {
                setShowLoggingIn(false)
                setFailMessage("Failed to login to Hikvision, please check your details and try again")
                setShowFail(true)
            }
        }
    }

    // Renders the current step's markup directly from state on every render (rather than
    // caching JSX via setState+useEffect), so a keystroke's updated value is reflected in the
    // very same render pass. Caching it in state meant the DOM briefly rendered the previous
    // (stale) value on the render right after a keystroke, which resets the input's caret to
    // the end - the "jump to end of text" bug.
    const renderModalComponent = () => {
        switch (modalPageIndex) {
            case 0:
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h2 style={{color:"#6e6e6e"}}>Which type of camera?</h2>
                        <br></br>
                        <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(1)}>Dahua</Button2>
                        <br/>
                         <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(11)}>Dahua NVR</Button2>
                        <br/>
                         <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(20)}>Hikvision</Button2>
                        <br/>
                         <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(21)}>Hikvision NVR</Button2>
                        <br/>
                         <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(10)}>RTSP Stream</Button2>
                        <br/>
                         <Button2  
                            style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }} 
                        onClick={() => setModalPageIndex(24)}>Ganz AIBOX</Button2>
                        {showCamect && (
                            <>
                                <br/>
                                <Button2
                                    disabled={!isPerCameraArming}
                                    style={{
                                    minWidth: "350px",
                                    minHeight: "50px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    opacity: isPerCameraArming ? 1 : 0.5,
                                    cursor: isPerCameraArming ? "pointer" : "not-allowed"
                                }}
                                onClick={() => setModalPageIndex(25)}>Camect</Button2>
                                {!isPerCameraArming && (
                                    <p style={{ margin: "6px 0 0 0", maxWidth: "350px", fontSize: "13px", textAlign: "center", color: "#6e6e6e" }}>
                                        Camect live view is only available when the site's CCTV integration type is set to 'Per camera arming'. This can be changed from the site Overview.
                                    </p>
                                )}
                            </> 
                        )}
                    </div>
                )
            case 1:
                return (
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add liveview camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddCamera("DAHUA")}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>

                )
            case 20:
                return (
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Hikvision camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP Port"}
                                ref={portRef}
                                id="rtspport"
                                value={rtspPortState.value}
                                onChange={rtspPortChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddCamera("HIKVISION")}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>

                )
            case 2:
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )
            case 8:
                //success
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Camera added successfully!</h3>
                        <br />
                        <Button
                            onClick={() => {HandleCloseModal(); fetchVirtualSources();}}
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                        />
                    </div>
                )
            case 9:
                //fail
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Failed to add camera</h3>
                        <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failReason}</h3>
                        <br />
                                  <Button onClick={HandleCloseModal} label="Close" severity='secondary'/>

                    </div>
                )
            case 10:
                return (
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add liveview camera</h2>
                            <p style={{color:"#6e6e6e"}}>Link your camera by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"Camera name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Stream URL"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={genericRtspURL}
                                onChange={rtspChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={HandleAddRTSP}>
                                {loading ? "Adding camera..." : "Add camera"}
                            </Button>
                        </div>
                    </div>

                )
            case 11:
                return (
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Dahua NVR</h2>
                            <p style={{color:"#6e6e6e"}}>Link your Dahua NVR by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"NVR name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP or HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddNVR("DAHUA")}>
                                {loading ? "Checking NVR..." : "Next"}
                            </Button>
                        </div>
                    </div>

                )
            case 21:
                return (
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Add Hikvision NVR</h2>
                            <p style={{color:"#6e6e6e"}}>Link your Hikvision NVR by completing the fields below</p>

                            <br></br>

                            <input
                                placeholder={"NVR name"}
                                id="cameraName"
                                value={cameraName}
                                onChange={cameraNameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"RTSP Port"}
                                ref={portRef}
                                id="rtspport"
                                value={rtspPortState.value}
                                onChange={rtspPortChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                             <SelectButton value={streamType} onChange={(e) => setStreamType(e.value)} options={["Main stream", "Sub stream"]} />

                            <br></br>

                            <Button severity="success" type="submit" disabled={loading} onClick={() => HandleAddNVR("HIKVISION")}>
                                {loading ? "Checking NVR..." : "Next"}
                            </Button>
                        </div>
                    </div>

                )
            case 12:
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <p>Which channels would you like to add?</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
                            {Array.from({ length: 16 }).map((_, i) => (
                                <Button
                                    key={`${i + 1}`}
                                    label={`${i + 1}`}
                                    className={selectedChannels.includes(`${i + 1}`) ? 'p-button-success' : 'p-button-outlined'}
                                    onClick={() => toggleButton(`${i + 1}`)}
                                />
                            ))}
                        </div>

                        <br/>
                        <Button label='Add channels' disabled={selectedChannels.length == 0} onClick={() => HandleAddChannels("DAHUA")}/>
                    </div>
                )
            case 23:
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <p>Which channels would you like to add?</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
                            {Array.from({ length: 16 }).map((_, i) => (
                                <Button
                                    key={`${i + 1}`}
                                    label={`${i + 1}`}
                                    className={selectedChannels.includes(`${i + 1}`) ? 'p-button-success' : 'p-button-outlined'}
                                    onClick={() => toggleButton(`${i + 1}`)}
                                />
                            ))}
                        </div>

                        <br/>
                        <Button label='Add channels' disabled={selectedChannels.length == 0} onClick={() => HandleAddChannels("HIKVISION")}/>
                    </div>
                )
            case 24: 
                return (
                    <div>
                        
                    </div>
                )
            case 25:
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h2 style={{color:"#6e6e6e"}}>Which Camect?</h2>
                         <p style={{ margin: "4px 0 0 0", color: "#9e9e9e", fontSize: "13px", textAlign: "center", maxWidth: "350px" }}>
                            Camects must be added to the site first before their cameras can be used for live view streaming.
                        </p>
                        <br></br>
                        {camectIntegrations === null && (
                            <p style={{ color: "#6e6e6e", fontSize: "14px" }}>Loading Camects...</p>
                        )}
                        {camectIntegrationsError && (
                            <p style={{ color: "#ee6d6d", fontSize: "14px" }}>Failed to load Camects, please try again.</p>
                        )}
                        {camectIntegrations?.length === 0 && !camectIntegrationsError && (
                            <p style={{ color: "#6e6e6e", fontSize: "14px", textAlign: "center", maxWidth: "350px" }}>
                                No Camects are linked to this site. Link one via CCTV Integration first.
                            </p>
                        )}
                        {camectIntegrations?.map((camect, index) => (
                            <React.Fragment key={camect.id}>
                                {index > 0 && <br/>}
                                <Button2
                                    style={{
                                    minWidth: "350px",
                                    minHeight: "50px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    wordBreak: "break-all"
                                }}
                                onClick={() => HandleSelectCamect(camect)}>{camect.address}</Button2>
                            </React.Fragment>
                        ))}
                    </div>
                )
            case 26:
                // Camera selection for the chosen Camect (selectedCamect) - cameras API to be added
                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h2 style={{color:"#6e6e6e"}}>Select cameras</h2>
                        <p style={{ color: "#6e6e6e", fontSize: "13px", wordBreak: "break-all", textAlign: "center" }}>{selectedCamect?.address}</p>
                        <br></br>
                        {availableCamectCameras === null && (
                            <p style={{ color: "#6e6e6e", fontSize: "14px" }}>Loading cameras...</p>
                        )}
                        {Array.isArray(availableCamectCameras) && availableCamectCameras.length === 0 && (
                            <p style={{ color: "#6e6e6e", fontSize: "14px", textAlign: "center", maxWidth: "350px" }}>
                                No cameras found on this Camect.
                            </p>
                        )}
                        {Array.isArray(availableCamectCameras) && availableCamectCameras.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "350px" }}>
                                {availableCamectCameras.map(camera => {
                                    const isSelected = selectedCamectCameras.some(c => c.id === camera.id);
                                    return (
                                        <button
                                            key={camera.id}
                                            type="button"
                                            onClick={() => toggleCamectCamera(camera)}
                                            style={{
                                                display: "flex", alignItems: "center", gap: "12px",
                                                padding: "12px 16px", textAlign: "left", cursor: "pointer",
                                                border: `2px solid ${isSelected ? "var(--Primary-Color)" : "#e0e0e0"}`,
                                                borderRadius: "8px", background: "white",
                                                transition: "border-color 0.15s ease",
                                            }}
                                        >
                                           <i className={isSelected ? "pi pi-check-square" : "pi pi-stop"} style={{ color: isSelected ? "var(--Primary-Color)" : "#9e9e9e" }} />
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>{camera.name}</p>
                                                <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e", wordBreak: "break-all" }}>{camera.id}</p>
                                            </div>
                                            <span style={{
                                                fontSize: "11px", fontWeight: 600, padding: "2px 8px", borderRadius: "10px", flexShrink: 0, whiteSpace: "nowrap",
                                                background: camera.is_streaming ? "#e8f5e9" : "#fdecea",
                                                color: camera.is_streaming ? "#2e7d32" : "#c0392b",
                                                border: `1px solid ${camera.is_streaming ? "#a5d6a7" : "#f5b7b1"}`,
                                            }}>
                                                {camera.is_streaming ? "Streaming" : "Not streaming"}
                                            </span>
                                        </button>
                                    );
                                })}

                                <br/>
                                    <Button label="Add cameras" severity="success" onClick={() => HandleLinkCamsForLiveView()} />
                            </div>
                            
                        )}
                    </div>
                )
            default:
                return null;
        }
    }

    // Opens the modal once per page transition, instead of on every keystroke.
    useEffect(() => {
        if (modalPageIndex !== null) {
            HandleShowModal();
        }
    }, [modalPageIndex]);

    return (
        <>

        <Modal ref={ModalDialog} title={"Add liveview camera"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {renderModalComponent()}
            </Modal>

        <Dialog
                header="Logging in"
                visible={showLoggingIn}
                style={{ width: "40vw" }}
                onHide={() => setShowLoggingIn(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={loggingInAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Attempting to connect, please wait...`}</h3>
                    <br />

                </div>
            </Dialog>

            <Dialog
                header="Please wait"
                visible={showAddingGeneric}
                style={{ width: "40vw" }}
                onHide={() => setShowAddingGeneric(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={loggingInAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Adding camera, please wait...`}</h3>
                    <br />

                </div>
            </Dialog>

            <Dialog
                header="Login Failed"
                visible={showDahuaLoginFailConfirm}
                style={{ width: "40vw" }}
                onHide={() => setShowDahuaLoginFailConfirm(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{ color: "#6e6e6eff", textAlign: "center" }}>Failed to login. Would you like to continue anyway?</h3>
                    <br />
                    <div style={{ display: "flex", gap: "1rem" }}>
                        <Button label="Yes, continue" severity="warning" onClick={HandleDahuaLoginFailContinue} />
                        <Button label="No, cancel" severity="secondary" onClick={() => setShowDahuaLoginFailConfirm(false)} />
                    </div>
                </div>
            </Dialog>

        </>
    )
}

export default LiveViewCameraForm;
